(() => {
  'use strict';
  if (window.RaptorCommerce) return;
  window.RaptorCommerce = true;
  const sourceVariantTitles = {"53659650621786":{"handle":"pack-athletics","title":"Pêche-Abricot / Cerise"},"53646092796250":{"handle":"endurance-performance","title":"Cerise"},"53646371946842":{"handle":"articulations-athletics","title":"Pêche-Abricot"},"49942822650202":{"handle":"la-gourde-raptor-nutrition","title":"Bleu"},"49942822715738":{"handle":"la-gourde-raptor-nutrition","title":"Blanc"},"49942927475034":{"handle":"la-gourde-raptor-nutrition","title":"Rouge"},"51928620335450":{"handle":"barre-proteinee-super-crunchy-peanuts-choco","title":"1 boîte"},"51928620368218":{"handle":"barre-proteinee-super-crunchy-peanuts-choco","title":"2 boîtes"},"46762209935706":{"handle":"pack-performance","title":"Fraise qui Pique ! / Agrumes Intenses / Pommes d'Automne"},"47649173111130":{"handle":"pack-performance","title":"Fraise qui Pique ! / Agrumes Intenses / Citron Vert Lime"},"46764855689562":{"handle":"pack-performance","title":"Fraise qui Pique ! / Framboise Acidulée / Pommes d'Automne"},"47649173143898":{"handle":"pack-performance","title":"Fraise qui Pique ! / Framboise Acidulée / Citron Vert Lime"},"54040483004762":{"handle":"pack-performance","title":"Fraise qui Pique ! / Thé Pêche / Pommes d'Automne"},"54040483037530":{"handle":"pack-performance","title":"Fraise qui Pique ! / Thé Pêche / Citron Vert Lime"},"49226927997274":{"handle":"pack-performance","title":"Ananas-Passion / Agrumes Intenses / Pommes d'Automne"},"49226928062810":{"handle":"pack-performance","title":"Ananas-Passion / Agrumes Intenses / Citron Vert Lime"},"49226928095578":{"handle":"pack-performance","title":"Ananas-Passion / Framboise Acidulée / Pommes d'Automne"},"49226928128346":{"handle":"pack-performance","title":"Ananas-Passion / Framboise Acidulée / Citron Vert Lime"},"54040483070298":{"handle":"pack-performance","title":"Ananas-Passion / Thé Pêche / Pommes d'Automne"},"54040483103066":{"handle":"pack-performance","title":"Ananas-Passion / Thé Pêche / Citron Vert Lime"},"49607474413914":{"handle":"pack-vitalite","title":"1 mois"},"49607474446682":{"handle":"pack-vitalite","title":"3 mois"},"49602217148762":{"handle":"probiotiques-digestion-systeme-immunitaire-humeur","title":"1 mois"},"49602217181530":{"handle":"probiotiques-digestion-systeme-immunitaire-humeur","title":"3 mois"},"49562955252058":{"handle":"whey-isolate-native-94-issue-du-lait-100-francais-copy","title":"Vanille Biscuit"},"49562944504154":{"handle":"whey-isolate-native-94-issue-du-lait-100-francais-copy","title":"Chocolat"},"49562944438618":{"handle":"whey-isolate-native-94-issue-du-lait-100-francais-copy","title":"Caramel salé"},"48260683596122":{"handle":"pack-women-edition-copie","title":"1 mois"},"48260683628890":{"handle":"pack-women-edition-copie","title":"3 mois"},"49338149241178":{"handle":"whey-isolate-native-94-caramel-sale","title":"Caramel salé"},"49585561960794":{"handle":"whey-isolate-native-94-caramel-sale","title":"Vanille Biscuit"},"49338149208410":{"handle":"whey-isolate-native-94-caramel-sale","title":"Chocolat"},"49337774342490":{"handle":"la-pate-du-maitre-elaboree-par-un-maitre-artisan-chocolatier-francais-copy","title":"Chocolat Noir Feuillantine / 1 pot"},"51680235389274":{"handle":"la-pate-du-maitre-elaboree-par-un-maitre-artisan-chocolatier-francais-copy","title":"Chocolat Noir Feuillantine / 2 pots"},"50437352915290":{"handle":"la-pate-du-maitre-elaboree-par-un-maitre-artisan-chocolatier-francais-copy","title":"Chocolat Noir Feuillantine / 3 pots"},"49337774276954":{"handle":"la-pate-du-maitre-elaboree-par-un-maitre-artisan-chocolatier-francais-copy","title":"Chocolat Noisette / 1 pot"},"51680235422042":{"handle":"la-pate-du-maitre-elaboree-par-un-maitre-artisan-chocolatier-francais-copy","title":"Chocolat Noisette / 2 pots"},"50437352948058":{"handle":"la-pate-du-maitre-elaboree-par-un-maitre-artisan-chocolatier-francais-copy","title":"Chocolat Noisette / 3 pots"},"47969898561882":{"handle":"mega-crispy-fruits-rouges-12-barres-proteinees","title":"1 boîte"},"47969898594650":{"handle":"mega-crispy-fruits-rouges-12-barres-proteinees","title":"2 boîtes"},"48021113897306":{"handle":"pack-trio-barres-gourmandes","title":"3 Boîtes"},"48021113930074":{"handle":"pack-trio-barres-gourmandes","title":"6 Boîtes"},"47656722465114":{"handle":"pack-women-edition","title":"1 mois / Orange Pamplemousse"},"47656722497882":{"handle":"pack-women-edition","title":"3 mois / Orange Pamplemousse"},"47656697659738":{"handle":"glowy-collagene-sticks","title":"Orange Pamplemousse / 1 mois"},"47656697692506":{"handle":"glowy-collagene-sticks","title":"Orange Pamplemousse / 3 mois"},"47656691499354":{"handle":"happy-bonne-humeur","title":"1 mois"},"47656691532122":{"handle":"happy-bonne-humeur","title":"3 mois"},"47656690811226":{"handle":"beauty-cheveux-et-ongles","title":"1 mois"},"47656690843994":{"handle":"beauty-cheveux-et-ongles","title":"3 mois"},"47524398465370":{"handle":"cafe-l-theanine-noisette-intense","title":"Noisette Intense / Capsules Nespresso / 3 boîtes (30 capsules)"},"47524398498138":{"handle":"cafe-l-theanine-noisette-intense","title":"Noisette Intense / Capsules Nespresso / 9 boîtes (90 capsules)"},"49329295229274":{"handle":"cafe-l-theanine-noisette-intense","title":"Noisette Intense / Moulu / 1 pack de 150g (30 portions)"},"49329295262042":{"handle":"cafe-l-theanine-noisette-intense","title":"Noisette Intense / Moulu / 3 packs de 150g (90 portions)"},"47303740719450":{"handle":"pack-equilibre-1","title":"1 mois"},"47303740752218":{"handle":"pack-equilibre-1","title":"3 mois"},"47303737016666":{"handle":"pack-energie","title":"1 mois"},"47303737049434":{"handle":"pack-energie","title":"3 mois"},"47324911403354":{"handle":"la-pate-du-maitre-pate-a-tartiner-chocolat-noisette","title":"Chocolat Noisette / 1 pot"},"51671018897754":{"handle":"la-pate-du-maitre-pate-a-tartiner-chocolat-noisette","title":"Chocolat Noisette / 2 pots"},"50437346099546":{"handle":"la-pate-du-maitre-pate-a-tartiner-chocolat-noisette","title":"Chocolat Noisette / 3 pots"},"48638640456026":{"handle":"la-pate-du-maitre-pate-a-tartiner-chocolat-noisette","title":"Chocolat Noir Feuillantine / 1 pot"},"51671018930522":{"handle":"la-pate-du-maitre-pate-a-tartiner-chocolat-noisette","title":"Chocolat Noir Feuillantine / 2 pots"},"50437346132314":{"handle":"la-pate-du-maitre-pate-a-tartiner-chocolat-noisette","title":"Chocolat Noir Feuillantine / 3 pots"},"47349207335258":{"handle":"carte-cadeau-raptor-nutrition","title":"50,00 €"},"47349207368026":{"handle":"carte-cadeau-raptor-nutrition","title":"100,00 €"},"47349207400794":{"handle":"carte-cadeau-raptor-nutrition","title":"200,00 €"},"47649815560538":{"handle":"elements-multivitamines-mineraux","title":"1 mois"},"47649815593306":{"handle":"elements-multivitamines-mineraux","title":"3 mois"},"47648309248346":{"handle":"chill-complexe-creatine-saveur-citron-vert-lime","title":"Citron Vert Lime"},"47648309182810":{"handle":"chill-complexe-creatine-saveur-citron-vert-lime","title":"Pommes d'Automne"},"47648992788826":{"handle":"play-intraworkout-saveur-agrumes-intenses","title":"Agrumes Intenses"},"50824213725530":{"handle":"play-intraworkout-saveur-agrumes-intenses","title":"Framboise Acidulée"},"54040546443610":{"handle":"play-intraworkout-saveur-agrumes-intenses","title":"Thé Pêche"},"47648967852378":{"handle":"work-preworkout-saveur-fraise-qui-pique","title":"WORK! / Fraise qui pique"},"49248860963162":{"handle":"work-preworkout-saveur-fraise-qui-pique","title":"WORK! / Ananas-Passion"},"54435264790874":{"handle":"work-preworkout-saveur-fraise-qui-pique","title":"WORK! / Cerise"},"54435264823642":{"handle":"work-preworkout-saveur-fraise-qui-pique","title":"ENDURANCE ♾️ / Fraise qui pique"},"54435264856410":{"handle":"work-preworkout-saveur-fraise-qui-pique","title":"ENDURANCE ♾️ / Ananas-Passion"},"54435264889178":{"handle":"work-preworkout-saveur-fraise-qui-pique","title":"ENDURANCE ♾️ / Cerise"},"47649066778970":{"handle":"whey-isolate-native-94","title":"Chocolat"},"47814107169114":{"handle":"whey-isolate-native-94","title":"Caramel salé"},"49585549672794":{"handle":"whey-isolate-native-94","title":"Vanille Biscuit"},"43739611627749":{"handle":"pack-barres-gourmandes","title":"Moelleux + Crousti"},"48037266456922":{"handle":"pack-barres-gourmandes","title":"Moelleux + Crispy"},"48037267702106":{"handle":"pack-barres-gourmandes","title":"Crousti + Crispy"},"47946647634266":{"handle":"barre-proteinee-trop-moelleux-chocolat","title":"1 boîte"},"47946647667034":{"handle":"barre-proteinee-trop-moelleux-chocolat","title":"2 boîtes"},"47946627907930":{"handle":"barre-proteinee-tres-crousti-choco-noisettes","title":"1 boîte"},"47946627940698":{"handle":"barre-proteinee-tres-crousti-choco-noisettes","title":"2 boîtes"},"47649812021594":{"handle":"limitless-fuel","title":"1 mois"},"47649812054362":{"handle":"limitless-fuel","title":"3 mois"},"47649807171930":{"handle":"berserk-fuel","title":"1 mois"},"47649807204698":{"handle":"berserk-fuel","title":"3 mois"},"43625925116133":{"handle":"pack-success","title":"1 mois"},"43625925148901":{"handle":"pack-success","title":"3 mois"},"43625855811813":{"handle":"pack-optimal","title":"1 mois"},"43625855844581":{"handle":"pack-optimal","title":"3 mois"},"47649911636314":{"handle":"tribulus","title":"1 mois"},"47649911669082":{"handle":"tribulus","title":"3 mois"},"43625933177061":{"handle":"pack-testo","title":"1 mois"},"43625933209829":{"handle":"pack-testo","title":"3 mois"},"43625885139173":{"handle":"pack-sommeil","title":"1 mois / Non"},"54787504931162":{"handle":"pack-sommeil","title":"1 mois / Oui"},"43625885171941":{"handle":"pack-sommeil","title":"3 mois / Non"},"54787504963930":{"handle":"pack-sommeil","title":"3 mois / Oui"},"43625826713829":{"handle":"pack-articulations","title":"1 mois"},"43625826746597":{"handle":"pack-articulations","title":"3 mois"},"43625847980261":{"handle":"pack-equilibre","title":"Essentiel / 1 mois / Non"},"54663175045466":{"handle":"pack-equilibre","title":"Essentiel / 1 mois / Oui"},"43625848013029":{"handle":"pack-equilibre","title":"Essentiel / 3 mois / Non"},"54663175078234":{"handle":"pack-equilibre","title":"Essentiel / 3 mois / Oui"},"54663175111002":{"handle":"pack-equilibre","title":"Complet / 1 mois / Non"},"54663175143770":{"handle":"pack-equilibre","title":"Complet / 1 mois / Oui"},"54663175176538":{"handle":"pack-equilibre","title":"Complet / 3 mois / Non"},"54663175209306":{"handle":"pack-equilibre","title":"Complet / 3 mois / Oui"},"43625861447909":{"handle":"pack-skincare","title":"1 mois"},"43625861480677":{"handle":"pack-skincare","title":"3 mois"},"47649840038234":{"handle":"collagene-marin-naticol","title":"15 jours"},"47649840071002":{"handle":"collagene-marin-naticol","title":"1 mois"},"47649840103770":{"handle":"collagene-marin-naticol","title":"3 mois"},"47649955217754":{"handle":"vitamine-d3","title":"1 mois"},"47649955250522":{"handle":"vitamine-d3","title":"3 mois"},"47649875231066":{"handle":"magnesium-bisglycinate","title":"1 mois"},"47649875362138":{"handle":"magnesium-bisglycinate","title":"3 mois"},"47649909834074":{"handle":"omega-3","title":"1 mois"},"47649909866842":{"handle":"omega-3","title":"3 mois"},"47649971798362":{"handle":"zinc-bisglycinate","title":"1 mois"},"47649971831130":{"handle":"zinc-bisglycinate","title":"3 mois"}};

  function prepareProductLinks(section) {
    const ownOrigin = new URL(document.baseURI).origin;
    const routeRoot = window.theme?.routes?.root || window.Shopify?.routes?.root || '/';
    section.querySelectorAll('.product-information a[href], .product-information a[data-source-url], .product-info__benefits a[href]').forEach(anchor => {
      const href = anchor.getAttribute('href') || anchor.dataset.sourceUrl;
      if (!href || href.startsWith('#')) return;
      let url;
      try { url = new URL(href, document.baseURI); } catch (_) { return; }
      const sourceOrigin = /^(www\.)?raptornutrition\.fr$|^raptornutrition\.myshopify\.com$/i.test(url.hostname);
      const internal = url.origin === ownOrigin || sourceOrigin;
      const documentation = /\.(pdf|docx?)(?:$|\?)/i.test(url.pathname) || url.pathname.startsWith('/cdn/');
      if (internal && !documentation && ['http:', 'https:'].includes(url.protocol)) {
        const sourceVariant = sourceVariantTitles[url.searchParams.get('variant')];
        if (sourceVariant && url.pathname.includes(`/products/${sourceVariant.handle}`)) {
          url.searchParams.delete('variant');
          url.searchParams.set('rn_variant', sourceVariant.title);
        }
        const path = url.pathname.replace(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?=products\/|collections\/|pages\/|policies\/)/i, '/');
        anchor.setAttribute('href', `${routeRoot.replace(/\/$/, '')}${path}${url.search}${url.hash}`);
        anchor.removeAttribute('target');
        return;
      }
      const reference = document.createElement('span');
      reference.className = `${anchor.className || ''} product-reference`.trim();
      reference.dataset.sourceUrl = url.href;
      const title = anchor.getAttribute('title') || url.hostname || 'Référence source';
      reference.setAttribute('title', `${title}\n${url.href}`);
      reference.setAttribute('aria-label', `${anchor.textContent.trim()} — ${title} — ${url.href}`);
      if (anchor.getAttribute('style')) reference.setAttribute('style', anchor.getAttribute('style'));
      reference.replaceChildren(...anchor.childNodes);
      anchor.replaceWith(reference);
    });
  }

  const money = (cents) => {
    if (typeof window.theme?.formatMoney === 'function') return window.theme.formatMoney(cents);
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency', currency: 'EUR'
    }).format(Number(cents || 0) / 100);
  };

  const discountedTotal = (price, quantity, active) => {
    const saving = active ? (quantity >= 2 ? Math.round(price * 0.3) : 0) + (quantity >= 3 ? Math.round(price * 0.4) : 0) : 0;
    return { total: price * quantity - saving, saving };
  };

  const ajaxUrl = (route) => {
    const url = new URL(route, document.baseURI);
    if (!url.pathname.endsWith('.js')) url.pathname += '.js';
    return url;
  };

  const componentForms = new WeakMap();
  const pspUnitPrices = new Set([999,1499,1999,2499,2999,3499,3999,4499]);
  let componentGroupSequence = 0;
  const positiveVariantId = value => /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0;
  function readComponentOffers(section) {
    try {
      const value = JSON.parse(section.querySelector('[data-psp-offers]')?.textContent || 'null');
      return value?.schema_version === 1 && value.currency === 'EUR' && value.offers && typeof value.offers === 'object' && !Array.isArray(value.offers) ? value : null;
    } catch (_) { return null; }
  }
  function componentOffer(configuration, variantId, count, currency = window.theme?.currency) {
    const unavailable = {total:0,unitPrice:0,comparePrice:0,saving:0,id:'',quantity:1,available:false,items:[]};
    if (!configuration || !positiveVariantId(variantId) || ![1,2,3].includes(count) || currency !== 'EUR') return unavailable;
    const offer = configuration.offers[String(variantId)]?.[String(count)];
    if (!offer || offer.available !== true || !Array.isArray(offer.items) || offer.items.length < 1 || offer.items.length > 100) return unavailable;
    if (!offer.items.every(item => item && positiveVariantId(item.id) && item.quantity === 1 && pspUnitPrices.has(item.unit_price) && typeof item.label === 'string' && item.label.trim().length > 0 && item.label.length <= 200)) return unavailable;
    const total = offer.items.reduce((sum,item) => sum + item.unit_price, 0);
    if (!Number.isSafeInteger(offer.reference_total) || offer.reference_total <= 0 || (offer.total !== undefined && offer.total !== total)) return unavailable;
    return {total,unitPrice:total,comparePrice:offer.reference_total,saving:Math.max(0,offer.reference_total-total),id:String(variantId),quantity:1,available:true,items:offer.items.map(item=>({...item,id:Number(item.id),label:item.label.trim()})),offerCount:count,label:typeof offer.label === 'string' && offer.label.trim().length <= 200 ? offer.label.trim() : `Formule ${count}`};
  }

  function componentArticlePrices(configuration, variantId, count) {
    const base = componentOffer(configuration, variantId, 1);
    const offer = componentOffer(configuration, variantId, count);
    if (!base.available || !offer.available || count < 2 || offer.items.length !== base.items.length * count) return '';
    const unit = base.items.length > 1 ? 'pack' : base.items[0].label.match(/\b1\s+(pot|bo[îi]te|sachet|paquet|flacon|pack)\b/i)?.[1].toLowerCase() || 'article';
    return Array.from({length:count - 1}, (_, index) => {
      const ordinal = index + 2;
      const total = offer.items.slice((ordinal - 1) * base.items.length, ordinal * base.items.length).reduce((sum, item) => sum + item.unit_price, 0);
      const saving = Math.max(0, base.total - total);
      const percent = new Intl.NumberFormat('fr-FR', {maximumFractionDigits:2}).format(saving * 100 / base.total);
      return `${ordinal}e ${unit} : ${money(total)}${saving > 0 ? ` (−${percent} %)` : ''}`;
    }).join(' · ');
  }

  const componentCartRoute = action => window.theme?.routes?.[action] || `${window.theme?.routes?.root || window.Shopify?.routes?.root || '/'}${action === 'cart_json' ? 'cart.js' : action === 'cart_change' ? 'cart/change.js' : 'cart/add.js'}`;
  async function componentCart() {
    const response = await fetch(ajaxUrl(componentCartRoute('cart_json')), {headers:{Accept:'application/json'}});
    const cart = await response.json();
    if (!response.ok || !Array.isArray(cart.items)) throw new Error('Impossible de vérifier votre panier. Réessayez dans un instant.');
    return cart;
  }
  async function removeComponentGroup(group) {
    let cart = await componentCart();
    const lines = cart.items.filter(item=>item.properties?._bundle_group === group);
    for (const line of lines) {
      const response = await fetch(ajaxUrl(componentCartRoute('cart_change')), {method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});
      if (!response.ok) throw new Error('Le retrait de la formule doit être vérifié dans votre panier.');
    }
    if (lines.length) cart = await componentCart();
    if (cart.items.some(item=>item.properties?._bundle_group === group)) throw new Error('Le retrait de la formule doit être vérifié dans votre panier.');
    return cart;
  }
  function componentResponseMatches(added, purchase, group) {
    if (!Array.isArray(added?.items) || added.items.length !== purchase.items.length) return false;
    return purchase.items.every((expected,index)=>{
      const matches = added.items.filter(item=>item.properties?._bundle_group === group && String(item.properties?._bundle_position) === String(index+1));
      if (matches.length !== 1) return false;
      const actual = matches[0];
      return String(actual.variant_id || actual.id) === String(expected.id) && actual.quantity === 1 && Number(actual.final_price ?? actual.price) === expected.unit_price && Number(actual.final_line_price ?? actual.line_price) === expected.unit_price;
    });
  }

  function showMedia(section, mediaId) {
    const items = [...section.querySelectorAll('.product-gallery__item[data-media-id]')];
    if (!items.some(item => item.dataset.mediaId === String(mediaId))) return;
    items.forEach(item => {
      const selected = item.dataset.mediaId === String(mediaId);
      item.hidden = !selected;
      if (selected) {
        const stage = item.closest('.product-gallery__stage');
        if (stage) stage.style.aspectRatio = item.dataset.aspectRatio || '1';
      }
      if (!selected) item.querySelectorAll('video').forEach(video => video.pause());
      if (selected && !window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) item.querySelectorAll('video[muted]').forEach(video => { video.play().catch(() => {}); });
    });
    section.querySelectorAll('[data-media-target]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(mediaId)));
    });
  }

  function initializeProduct(section) {
    if (section.dataset.commerceReady) return;
    section.dataset.commerceReady = 'true';
    prepareProductLinks(section);
    const form = section.querySelector('form[data-product-form]');
    if (!form) return;
    const selector = form.querySelector('[data-variant-select]');
    const quantityInput = form.querySelector('[data-visible-quantity]');
    const purchaseVariant = form.querySelector('[data-purchase-variant]');
    const purchaseQuantity = form.querySelector('[data-purchase-quantity]');
    const addButton = form.querySelector('[data-add-button]');
    const eligible = selector?.dataset.consumable === 'true';
    const active = section.dataset.bundleActive === 'true' && eligible;
    const preview = section.dataset.bundlePreview === 'true' && eligible;
    const nativeBundles = section.dataset.nativeBundles === 'true' && eligible;
    const components = section.dataset.pspComponentBundles === 'true';
    const componentConfiguration = components ? readComponentOffers(section) : null;
    let componentBlock = '';
    const requestedTitle = new URL(document.URL).searchParams.get('rn_variant');
    if (requestedTitle && selector) {
      const requestedOption = [...selector.options].find(option => option.textContent.replace(' — Indisponible', '').trim() === requestedTitle);
      if (requestedOption) selector.value = requestedOption.value;
    }
    const applyCommercialSelection = () => {
      if (!components || !selector || !quantityInput) return;
      const binding = componentConfiguration?.parents?.[String(selector.value)];
      if (!binding) return;
      const canonical = String(binding.canonical_base_variant_id || selector.value);
      if ([...selector.options].some(option=>option.value===canonical)) selector.value=canonical;
      if ([1,2,3].includes(Number(binding.initial_offer))) quantityInput.value=String(binding.initial_offer);
    };
    applyCommercialSelection();
    section.querySelectorAll('.product-gallery__stage, .product-gallery__thumbnails').forEach(container => {
      [...container.querySelectorAll('[data-source-position]')].sort((a, b) => Number(a.dataset.sourcePosition) - Number(b.dataset.sourcePosition)).forEach(item => {
        container.insertBefore(item, container.children[Number(item.dataset.sourcePosition)] || null);
      });
    });
    const mediaItems = [...section.querySelectorAll('.product-gallery__item[data-media-id]')];
    if (mediaItems.length > 1) {
      const dots = document.createElement('div');
      dots.className = 'product-gallery__dots';
      dots.setAttribute('aria-label', 'Choisir un média');
      mediaItems.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.mediaTarget = item.dataset.mediaId;
        dot.setAttribute('aria-label', `Média ${index + 1}`);
        dot.setAttribute('aria-pressed', String(!item.hidden));
        dots.append(dot);
      });
      section.querySelector('.product-gallery__stage')?.after(dots);
      let touchStart = null;
      const stage = section.querySelector('.product-gallery__stage');
      stage?.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' && !event.target.closest('video')) touchStart = event.clientX;
      });
      stage?.addEventListener('pointerup', event => {
        if (touchStart === null) return;
        const delta = event.clientX - touchStart;
        touchStart = null;
        if (Math.abs(delta) < 45) return;
        const current = mediaItems.findIndex(item => !item.hidden);
        const next = (current + (delta < 0 ? 1 : -1) + mediaItems.length) % mediaItems.length;
        showMedia(section, mediaItems[next].dataset.mediaId);
      });
    }
    const offerTotal = (option, quantity, previewPrices = false) => {
      if (components) return componentBlock ? {total:0,unitPrice:0,comparePrice:0,saving:0,id:'',quantity:1,available:false,items:[]} : componentOffer(componentConfiguration, option.value, quantity);
      const price = Number(option.dataset.price || 0);
      const packId = quantity === 2 || quantity === 3 ? option.dataset[`pack${quantity}Id`] : null;
      if (nativeBundles && packId) {
        const total = Number(option.dataset[`pack${quantity}Price`]);
        return { total, unitPrice: total, comparePrice: Number(option.dataset[`pack${quantity}ComparePrice`] || 0), saving: Math.max(0, price * quantity - total), id: packId, quantity: 1, available: option.dataset[`pack${quantity}Available`] === 'true' };
      }
      const result = discountedTotal(price, quantity, !nativeBundles && (active || previewPrices));
      return { ...result, unitPrice: price, comparePrice: Number(option.dataset.comparePrice || 0), id: option.value, quantity, available: option.dataset.available === 'true' };
    };

    const updateProduct = () => {
      const option = selector?.selectedOptions[0];
      if (!option || !quantityInput) return;
      const price = Number(option.dataset.price || 0);
      const comparePrice = Number(option.dataset.comparePrice || 0);
      const selectedValues = JSON.parse(option.dataset.options || '[]');
      form.querySelectorAll('[data-product-option]').forEach(radio => {
        const index = Number(radio.dataset.productOption);
        radio.checked = selectedValues[index] === radio.value;
        const compatible = [...selector.options].filter(candidate => {
          const values = JSON.parse(candidate.dataset.options || '[]');
          return values[index] === radio.value && values.slice(0, index).every((value, previous) => value === selectedValues[previous]);
        });
        radio.disabled = compatible.length === 0;
        const unavailable = compatible.length > 0 && !compatible.some(candidate => components ? offerTotal(candidate, Number(quantityInput.value) || 1).available : candidate.dataset.available === 'true');
        radio.nextElementSibling?.classList.toggle('disabled', radio.disabled || unavailable);
        radio.nextElementSibling?.setAttribute('data-unavailable', String(unavailable));
      });
      const minimum = components ? 1 : Number(option.dataset.quantityMin || 1);
      const increment = components ? 1 : Number(option.dataset.quantityIncrement || 1);
      const maximum = components ? 3 : option.dataset.quantityMax ? Number(option.dataset.quantityMax) : null;
      quantityInput.min = String(minimum);
      quantityInput.step = String(increment);
      if (maximum !== null) quantityInput.max = String(maximum);
      else quantityInput.removeAttribute('max');
      let quantity = Math.max(minimum, Number(quantityInput.value) || minimum);
      quantity = minimum + Math.round((quantity - minimum) / increment) * increment;
      if (maximum !== null) quantity = Math.min(maximum, quantity);
      quantityInput.value = String(quantity);
      const purchase = offerTotal(option, quantity);
      const available = purchase.available;
      if (purchaseVariant) {
        const changed = purchaseVariant.value !== purchase.id;
        purchaseVariant.value = purchase.id;
        if (changed) purchaseVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (purchaseQuantity) purchaseQuantity.value = String(purchase.quantity);
      const priceNode = section.querySelector('[data-product-price]');
      const compareNode = section.querySelector('[data-product-compare]');
      if (priceNode) priceNode.textContent = components && !available ? 'Formule indisponible' : money(purchase.unitPrice);
      if (compareNode) {
        compareNode.textContent = money(purchase.comparePrice);
        compareNode.hidden = purchase.comparePrice <= purchase.unitPrice;
      }
      const referenceLabel = section.querySelector('[data-psp-reference-label]');
      if (referenceLabel) referenceLabel.hidden = !components || !available || purchase.comparePrice <= purchase.unitPrice;
      if (addButton && !form.hasAttribute('aria-busy')) addButton.disabled = !available;
      const label = form.querySelector('[data-add-label]');
      if (label) label.textContent = available ? 'Ajouter au panier' : components ? 'Formule indisponible' : 'Indisponible';
      const availability = section.querySelector('[data-product-availability]');
      if (availability) availability.textContent = available ? 'En stock' : components ? 'Formule indisponible' : 'Épuisé';
      const inventoryIcon = section.querySelector('[data-inventory-icon]');
      if (inventoryIcon) inventoryIcon.hidden = !available;
      if (addButton) addButton.dataset.available = String(available);
      const addTotal = form.querySelector('[data-add-total]');
      if (addTotal) addTotal.textContent = components && !available ? '' : money(purchase.total);
      if (components) {
        const error = form.querySelector('[data-product-error]');
        if (error && (!available || error.dataset.pspConfiguration === 'true')) {
          error.textContent = available ? '' : componentBlock || 'Cette formule est momentanément indisponible. Choisissez une autre formule.';
          error.hidden = available;
          error.dataset.pspConfiguration = String(!available);
        }
        const list = form.querySelector('[data-psp-selected-items]');
        if (list) {
          const summaries = new Map();
          purchase.items.forEach(item=>{
            const key=positiveVariantId(item.physical_source_variant_id)?JSON.stringify(['physical',String(item.physical_source_variant_id),item.quantity_unit,item.physical_options]):JSON.stringify(['technical',String(item.id),item.label,item.unit_price]);
            if(summaries.has(key)){const group=summaries.get(key);group.count++;group.prices.push(item.unit_price);group.total+=item.unit_price;}
            else summaries.set(key,{...item,count:1,prices:[item.unit_price],total:item.unit_price});
          });
          list.replaceChildren(...[...summaries.values()].map(item=>{
            const row = document.createElement('li');row.dataset.pspSummaryCount=String(item.count);
            const name = document.createElement('span');
            let label=item.label;
            if(item.count>1){
              if(/\b1 pot\b/i.test(label))label=label.replace(/\b1 pot\b/i,item.count+' pots');
              else if(/\b1 bo[îi]te\b/i.test(label))label=label.replace(/\b1 bo[îi]te\b/i,item.count+' boîtes');
              else if(/\b1 format mensuel\b/i.test(label))label=label.replace(/\b1 format mensuel\b/i,item.count+' formats mensuels');
              else label+=' × '+item.count;
            }
            name.textContent=label;
            const samePrice=item.prices.every(price=>price===item.prices[0]);
            const price = document.createElement('strong');price.textContent=samePrice&&item.count>1?item.count+' × '+money(item.unit_price):money(item.total);
            row.append(name,price);
            if(!samePrice){const detail=document.createElement('small');detail.className='psp-summary-prices';detail.textContent=item.prices.map(money).join(' + ');row.append(detail);}
            return row;
          }));
          list.hidden = !available;
        }
      }

      const duration = option.textContent.match(/\b(\d+)\s*mois\b/i);
      const monthsPerUnit = Number(section.dataset.unitMonths || 0) || (duration ? Number(duration[1]) : 0);
      if(components)form.querySelectorAll('[data-option-group]').forEach(group=>{
        const wrapper=group.closest('.variant-wrapper'),name=wrapper?.querySelector('.variant__label')?.textContent || '';
        if(!/dur[eé]e/i.test(name))return;
        const index=Number(group.dataset.optionGroup),chosen=JSON.parse(option.dataset.options || '[]');
        const compatible=[...selector.options].filter(candidate=>JSON.parse(candidate.dataset.options || '[]').every((value,position)=>position===index || value===chosen[position]));
        const values=new Set(compatible.map(candidate=>JSON.parse(candidate.dataset.options || '[]')[index]));
        const canonical=new Set(compatible.map(candidate=>String(componentConfiguration?.parents?.[candidate.value]?.canonical_base_variant_id || candidate.value)));
        if(wrapper)wrapper.hidden=values.size>1 && [...values].every(value=>/^(1|3)\s*mois$/i.test(value)) && canonical.size===1;
      });
      form.querySelectorAll('[data-bundle-quantity]').forEach(radio => {
        const count = Number(radio.value);
        radio.checked = count === quantity;
        radio.disabled = components ? !offerTotal(option,count).available : nativeBundles && count > 1 ? !option.dataset[`pack${count}Id`] || option.dataset[`pack${count}Available`] !== 'true' : count < minimum || (maximum !== null && count > maximum) || (count - minimum) % increment !== 0;
      });
      form.querySelectorAll('[data-bundle-label]').forEach(node => {
        const count = Number(node.dataset.bundleLabel);
        const configured = componentConfiguration?.offers?.[String(option.value)]?.[String(count)];
        node.textContent = components ? (typeof configured?.label === 'string' && configured.label.trim() ? configured.label.trim() : `Formule ${count}`) : monthsPerUnit > 0 ? `${count * monthsPerUnit} mois` : `${count} produit${count > 1 ? 's' : ''}`;
        const tile = node.closest('[data-bundle-tile],.bundle-tile');
        if (tile) tile.hidden = components && !configured;
        const description = tile?.querySelector('[data-bundle-description]');
        if (description && components) {
          description.textContent = typeof configured?.description === 'string' ? configured.description : '';
          description.hidden = !description.textContent.trim();
        }
      });
      form.querySelectorAll('[data-bundle-image]').forEach(image=>{
        const count=Number(image.closest('.bundle-tile')?.querySelector('[data-bundle-quantity]')?.value);
        const configured=componentConfiguration?.offers?.[String(option.value)]?.[String(count)];
        if(components && configured?.items?.length && configured.items.every(item=>item.physical_source_handle===section.dataset.productHandle)){
          const source=configured.items.find(item=>typeof item.image_url==='string'&&item.image_url)?.image_url;
          if(source){try{const url=new URL(source,document.baseURI);if(['http:','https:'].includes(url.protocol))image.src=url.href;}catch{}}
        }
      });
      form.querySelectorAll('[data-bundle-total]').forEach(node => {
        const offer = offerTotal(option, Number(node.dataset.bundleTotal), preview);
        node.textContent = components && !offer.available ? 'Indisponible' : money(offer.total);
      });
      form.querySelectorAll('[data-bundle-saving]').forEach(node => {
        const saving = offerTotal(option, Number(node.dataset.bundleSaving), preview).saving;
        node.textContent = `Économisez ${money(saving)}`;
        node.hidden = saving <= 0;
      });
      form.querySelectorAll('[data-bundle-badge]').forEach(node => {
        const count = Number(node.closest('.bundle-tile').querySelector('[data-bundle-quantity]').value);
        const actualSaving = offerTotal(option, count, preview).saving;
        if (components) {
          node.textContent = offerTotal(option, count).available ? componentArticlePrices(componentConfiguration, option.value, count) : '';
          node.hidden = !node.textContent;
          return;
        }
        const expectedSaving = discountedTotal(price, count, true).saving;
        node.hidden = actualSaving <= 0 || actualSaving !== expectedSaving;
      });
    };

    if (components) componentForms.set(form, {
      purchase: () => {
        const option = selector?.selectedOptions[0];
        const count = Number(quantityInput?.value);
        return option ? offerTotal(option,count) : null;
      },
      block: message => { componentBlock = message;updateProduct(); },
      update: updateProduct
    });

    selector?.addEventListener('change', () => {
      applyCommercialSelection();
      updateProduct();
      if (selector.selectedOptions[0]?.dataset.mediaId) showMedia(section, selector.selectedOptions[0].dataset.mediaId);
    });
    const optionGroups = form.querySelector('[data-product-option-groups]');
    if (optionGroups) {
      optionGroups.hidden = false;
      selector.hidden = true;
      const label = form.querySelector('[data-variant-label]');
      if (label) label.hidden = true;
      optionGroups.addEventListener('change', event => {
        const changed = event.target.closest('[data-product-option]');
        if (!changed) return;
        const chosen = [...optionGroups.querySelectorAll('[data-option-group]')].map(group => group.querySelector('input:checked')?.value);
        const candidates = [...selector.options];
        const matching = candidates.find(option => JSON.parse(option.dataset.options || '[]').every((value, index) => value === chosen[index])) || candidates.find(option => JSON.parse(option.dataset.options || '[]').every((value, index) => index > Number(changed.dataset.productOption) || value === chosen[index]));
        if (matching) {
          selector.value = matching.value;
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    quantityInput?.addEventListener('change', updateProduct);
    form.querySelectorAll('[data-bundle-quantity]').forEach(radio => {
      radio.addEventListener('change', () => {
        if (radio.checked && quantityInput) quantityInput.value = radio.value;
        updateProduct();
      });
    });
    section.querySelectorAll('[data-media-target]').forEach(button => {
      button.addEventListener('click', () => showMedia(section, button.dataset.mediaTarget));
    });
    updateProduct();
    if (requestedTitle && selector?.selectedOptions[0]?.dataset.mediaId) showMedia(section, selector.selectedOptions[0].dataset.mediaId);
  }

  async function openQuickShop(opener) {
    let dialog = document.getElementById('quick-shop-dialog');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'quick-shop-dialog';
      dialog.className = 'dialog quick-shop-dialog';
      dialog.setAttribute('aria-labelledby', 'quick-shop-title');
      dialog.innerHTML = '<div class="dialog-header"><h2 id="quick-shop-title">Aperçu du produit</h2><button type="button" class="icon-button" data-dialog-close aria-label="Fermer l’aperçu">×</button></div><div class="quick-shop-dialog__content" data-quick-content role="status">Chargement…</div>';
      document.body.append(dialog);
    }
    const content = dialog.querySelector('[data-quick-content]');
    content.textContent = 'Chargement…';
    if (typeof window.theme?.openDialog === 'function') window.theme.openDialog(dialog.id, opener);
    else dialog.showModal();
    try {
      const url = new URL(opener.dataset.quickShopUrl, document.baseURI);
      url.searchParams.set('view', 'quick');
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Le produit n’a pas pu être chargé.');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section = parsed.querySelector('[data-product-section]');
      if (!section) throw new Error('Consultez la fiche pour choisir votre formule.');
      const product = section.closest('.source-pdp') || section;
      const sourceStylesheet = parsed.querySelector('link[href*="product-source.css"]');
      if (sourceStylesheet && !document.querySelector('link[href*="product-source.css"]')) document.head.append(sourceStylesheet.cloneNode());
      content.replaceChildren(product);
      content.removeAttribute('role');
      initialize(content);
      const title = product.querySelector('.product-info__title');
      if (title) document.getElementById('quick-shop-title').textContent = title.textContent;
    } catch (failure) {
      content.textContent = failure.message;
      const link = document.createElement('a');
      link.href = opener.dataset.quickShopUrl;
      link.className = 'button';
      link.textContent = 'Consulter le produit';
      content.append(link);
    }
  }

  async function addProduct(event) {
    const form = event.target.closest('form[data-product-form]');
    if (!form || (event.submitter && event.submitter.name !== 'add')) return;
    event.preventDefault();
    if (form.hasAttribute('aria-busy')) return;
    const button = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-product-error]');
    const status = form.querySelector('[data-product-status]');
    if (error) { error.hidden = true; error.textContent = ''; }
    if (status) status.textContent = '';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    const componentController = componentForms.get(form);
    const lockedControls = [];
    try {
      const route = window.theme?.routes?.cart_add || `${window.Shopify?.routes?.root || '/'}cart/add`;
      let added;
      if (componentController) {
        const purchase = componentController.purchase();
        if (!purchase?.available) throw new Error('Cette formule est indisponible. Choisissez une autre formule.');
        form.querySelectorAll('input:not([type="hidden"]),select,button').forEach(control=>{
          lockedControls.push({control,disabled:control.disabled});control.disabled = true;
        });
        const before = await componentCart();
        if (before.currency !== 'EUR') {
          componentController.block('Ces formules sont disponibles uniquement en EUR.');
          throw new Error('Ces formules sont disponibles uniquement en EUR.');
        }
        const group = `rn-${Date.now().toString(36)}-${++componentGroupSequence}-${Math.random().toString(36).slice(2,10)}`;
        const productSection = form.closest('[data-product-section]');
        const productTitle = productSection?.querySelector('.product-info__title')?.textContent.trim() || 'Votre sélection';
        const productHandle = productSection?.dataset.productHandle || '';
        const items = purchase.items.map((item,index)=>({id:item.id,quantity:1,properties:{
          _bundle_group:group,_bundle_parent:purchase.id,_bundle_parent_handle:productHandle,_bundle_count:String(purchase.items.length),_bundle_offer:String(purchase.offerCount),_bundle_position:String(index+1),
          Formule:purchase.label || `${purchase.offerCount} × ${productTitle}`,Article:item.label
        }}));
        try {
          const response = await fetch(ajaxUrl(route), {method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items})});
          added = await response.json();
          if (!response.ok) throw new Error(added.description || added.message || 'La disponibilité de cette formule a changé.');
          if (!componentResponseMatches(added,purchase,group)) throw new Error('Les prix de cette formule ont changé.');
        } catch (failure) {
          let removed = false;
          try {
            const cart = await removeComponentGroup(group);
            window.theme?.renderCart?.(cart);
            removed = true;
          } catch (_) { /* Keep the verification error visible when cleanup cannot be confirmed. */ }
          const message = `${failure.message || 'La formule n’a pas pu être validée.'} ${removed ? 'La formule a été retirée du panier. Rechargez la page avant de réessayer.' : 'Vérifiez votre panier avant de poursuivre.'}`;
          componentController.block(message);
          throw new Error(message);
        }
      } else {
        const data = new FormData(form);
        data.delete('bundle-quantity');
        data.delete('base_variant');
        data.delete('purchase_quantity');
        const response = await fetch(ajaxUrl(route), { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        added = await response.json();
        if (!response.ok) throw new Error(added.description || added.message || 'Impossible d’ajouter ce produit au panier.');
      }
      if (status) status.textContent = 'Produit ajouté à votre panier.';
      document.dispatchEvent(new CustomEvent('theme:cart-updated', { detail: { added } }));
      if (typeof window.theme?.refreshCart === 'function') {
        try { await window.theme.refreshCart(true); } catch (_) { /* The item was added; preserve success state if refreshing fails. */ }
      }
    } catch (failure) {
      if (error) { error.textContent = failure.message || 'Une erreur est survenue. Veuillez réessayer.'; error.hidden = false; }
    } finally {
      form.removeAttribute('aria-busy');
      lockedControls.forEach(({control,disabled})=>{control.disabled=disabled;});
      componentController?.update();
      if (button) button.disabled = button.dataset.available === 'false';
    }
  }

  async function loadRecommendations(element) {
    if (element.dataset.loaded || !element.dataset.productId || !element.hidden) return;
    element.dataset.loaded = 'true';
    try {
      const url = new URL(element.dataset.url, document.baseURI);
      url.searchParams.set('product_id', element.dataset.productId);
      url.searchParams.set('section_id', element.dataset.sectionId);
      url.searchParams.set('limit', element.dataset.limit || '4');
      url.searchParams.set('intent', 'related');
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = parsed.querySelector('[data-product-recommendations]');
      if (content && !content.hidden && content.querySelector('.product-card')) {
        element.innerHTML = content.innerHTML;
        element.hidden = false;
      }
    } catch (_) { /* Native recommendations stay hidden when Shopify returns none or the connection fails. */ }
  }

  function initialize(root = document) {
    root.querySelectorAll('button[name="checkout"]').forEach(button => {
      button.disabled = false;
      button.formNoValidate = true;
      button.removeAttribute('aria-disabled');
      button.removeAttribute('data-psp-checkout-guard');
    });
    root.querySelectorAll('[data-product-section]').forEach(initializeProduct);
    root.querySelectorAll('[data-product-recommendations]').forEach(loadRecommendations);
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) root.querySelectorAll('iframe[data-source-vimeo]').forEach(frame => {
      if (frame.dataset.motionReady) return;
      frame.dataset.motionReady = 'true';
      const url = new URL(frame.src, document.baseURI);
      url.searchParams.set('autoplay', '0');
      url.searchParams.set('background', '0');
      url.searchParams.set('loop', '0');
      frame.src = url.href;
    });
    root.querySelectorAll('[data-collection-sort]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const fallback = select.form?.querySelector('[data-sort-fallback]');
      if (fallback) fallback.hidden = true;
      select.addEventListener('change', () => select.form?.requestSubmit());
    });
  }

  document.addEventListener('submit', addProduct);
  document.addEventListener('click', event => {
    if (event.defaultPrevented) return;
    const zoom = event.target.closest('[data-product-zoom]');
    if (zoom) {
      const sourceImage = zoom.closest('.product-gallery__item')?.querySelector('img');
      if (!sourceImage) return;
      let dialog = document.getElementById('product-zoom-dialog');
      if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.id = 'product-zoom-dialog';
        dialog.className = 'dialog product-zoom-dialog';
        dialog.setAttribute('aria-label', 'Image agrandie du produit');
        dialog.innerHTML = '<button type="button" class="icon-button" data-dialog-close aria-label="Fermer l’image agrandie">×</button><div data-zoom-content></div>';
        document.body.append(dialog);
      }
      const enlarged = sourceImage.cloneNode();
      enlarged.loading = 'eager';
      enlarged.sizes = '95vw';
      dialog.querySelector('[data-zoom-content]').replaceChildren(enlarged);
      dialog.showModal();
      return;
    }
    const quickShop = event.target.closest('[data-quick-shop-url]');
    if (quickShop) {
      event.preventDefault();
      openQuickShop(quickShop);
      return;
    }
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;
    const input = button.closest('.quantity-input')?.querySelector('input[type="number"]');
    if (!input) return;
    event.preventDefault();
    if (Number(button.dataset.quantityStep) > 0) input.stepUp();
    else input.stepDown();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();

